import moment from "moment";
// tslint:disable
/**
 * 判断出入数组内是否存在目标值
 * @author yangyongheng
 * @date 2019-01-11
 * @param {(Array<string | number>)} lists
 * @param {(string | number)} value
 * @returns {boolean}
 */
export function ArrayIncludes_(lists, value) {
    if (!Array.isArray(lists) || !lists.length) {
        return false;
    }
    const target = lists.find(item => item === value);
    if (target !== undefined) {
        return true;
    }
    return false;
}
/**
 * 元素滚动到可视区域，暂时只支持类名
 * @author yangyongheng
 * @date 2019-01-31
 * @param {string} className 暂时只支持类名
 * @default auto
 * @param {("auto" | "smooth")} [behavior]
 */
export function scrollIntoView(className, behavior) {
    document.getElementsByClassName(className)[0] &&
        document
            .getElementsByClassName(className)[0]
            .scrollIntoView({ behavior: undefined });
}
/**
 * 当前选择在所有序列中索引
 * @memberof Timeline
 */
export function IndexOfDyadicArray(dates, index) {
    let count = 0;
    for (let i = 0; i < index; i++) {
        count += dates[i].children.length;
    }
    return count;
}
/**
 * 查找给定字符在数组中的索引
 * @private
 * @param {*} value
 * @param {string[]} data
 * @returns
 */
export function indexOf_(value, data) {
    const index = data.indexOf(value);
    return index;
}
export function toNumber(value) {
    return Number(value) ? Number(value) : "";
}
/**
 * 校验是否为简单数据格式
 * @param {TimelineProps["data"]} data
 * @returns {data is Array<string>}
 */
export function isSimpleData(data) {
    if (typeof data[0] === "string") {
        return true;
    }
    return false;
}
/**
 * 带url的时间类型
 * key 必须是时间
 * @param {TimelineProps["data"]} data
 * @returns {data is Array<{ key: string; url: string }>}
 */
export function isSimpleDataWithUrl(data) {
    // @ts-ignore
    if (typeof data[0] === "object" && data[0].url && isValidDate(data[0].key)) {
        return true;
    }
    return false;
}
/**
 * 带url的时间类型
 * key 必须是时间
 * @param {TimelineProps["data"]} data
 * @returns {data is Array<{ key: string; url: string }>}
 */
export function isSimpleDataWithChildren(data) {
    // @ts-ignore
    if (data[0].children && typeof data[0].children === "object") {
        return true;
    }
    return false;
}
/**
 * 校验时间的合法性
 * @param {(string | Date | moment.Moment)} date
 * @returns {boolean}
 */
export function isValidDate(date) {
    return moment(date).isValid();
}
/**
 * 合并复杂数据类型中的children为一维数组
 * @param {(({ children: TimelineComplexDate[]; } & TimelineComplexDate)[])} dateGrouping
 * @returns {Array<TimelineComplexDate>}
 */
export function mergeChildrens(dateGrouping) {
    const dataChildrens = dateGrouping.map(item => item.children);
    const dateChildrens = Array.prototype.concat.apply([], dataChildrens);
    return dateChildrens;
}
//# sourceMappingURL=utils.js.map